// OPS Occult Library comparative visual archive — multi-source historical reference renderer.
(()=>{
  const SOURCE_PACKS = {
    '1648 chyromancy hands — mapping symbols onto the body': [
      {
        date:'1648',
        period:'Mid-17th century',
        creator:'Unknown English manuscript author / draughtsperson',
        work:'Chyromancy or Palmestrye. Also Physiognomy and Metoposcopie — illustration of three hands',
        page:'MS.8727, final illustrated pages; image L0068571',
        institution:'Wellcome Collection, London',
        collection:'MS.8727',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Illustration_of_3_hands_in_Chyromancy_Wellcome_L0068571.jpg?width=1200',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Illustration_of_3_hands_in_Chyromancy_Wellcome_L0068571.jpg',
        rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',
        rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
        attribution:'Illustration of 3 hands in Chyromancy, 1648, MS.8727, Wellcome Collection, London, image L0068571. CC BY 4.0.',
        note:'The manuscript source already used by this entry: a compact body-map where palm lines, finger divisions and symbolic marks share one recognisable hand silhouette.'
      },
      {
        date:'1685',
        period:'Late 17th century',
        creator:'William Salmon; engraving associated with Frederick Hendrick van Hove',
        work:'Plate XXII: Palmistry chart of right hand',
        page:'Plate XXII; chapters 35–50 referenced by the plate',
        institution:'Science History Institute, Philadelphia',
        collection:'Digitised through Science History Institute / DPLA',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Plate_XXII-_Palmistry_chart_of_right_hand_-_DPLA_-_2e7beac1623e708c1e7a59732d068151.jpg?width=1200',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Plate_XXII-_Palmistry_chart_of_right_hand_-_DPLA_-_2e7beac1623e708c1e7a59732d068151.jpg',
        rights:'Public domain; Commons records Public Domain Mark 1.0 metadata for the institutional scan',
        rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
        attribution:'William Salmon, Plate XXII: Palmistry chart of right hand, 1685. Science History Institute; digitised via DPLA.',
        note:'Only a generation later, the hand becomes a more formal engraved index: planetary signs and named creases are organised into a printed reference system.'
      },
      {
        date:'Late 19th century',
        period:'Late 19th century',
        creator:'Unidentified lithographer / publisher; Wellcome iconographic collection',
        work:'Chart showing the basic elements of phrenology, physiognomy and palmistry',
        page:'Single colour lithographic chart; Wellcome photo V0009525',
        institution:'Wellcome Collection, London',
        collection:'Iconographic Collections; ICV No 9771',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Chart_showing_the_basic_elements_of_phrenology%2C_physiognomy_Wellcome_V0009525.jpg?width=1400',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Chart_showing_the_basic_elements_of_phrenology,_physiognomy_Wellcome_V0009525.jpg',
        rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',
        rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
        attribution:'Chart showing the basic elements of phrenology, physiognomy and palmistry, late 19th century. Wellcome Collection, V0009525. CC BY 4.0.',
        note:'By the late nineteenth century palm diagrams are absorbed into broad popular classification charts, sharing the page with physiognomy and phrenology.'
      },
      {
        date:'1904',
        period:'Early 20th century',
        creator:'Elmo Jean La Seer',
        work:'Chief Lines of the Hand, from Illustrated Palmistry: The Science of the Hand & Its Lines',
        page:'p. 22',
        institution:'Digitised public-domain book source; reproduction hosted by Wikimedia Commons',
        collection:'Illustrated Palmistry: The Science of the Hand & Its Lines',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Chief_Lines_of_the_Hand.jpg?width=1000',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Chief_Lines_of_the_Hand.jpg',
        rights:'Public domain (published 1904; Commons PD-US-expired)',
        rightsUrl:'https://commons.wikimedia.org/wiki/File:Chief_Lines_of_the_Hand.jpg#Licensing',
        attribution:'Elmo Jean La Seer, Chief Lines of the Hand, Illustrated Palmistry: The Science of the Hand & Its Lines, 1904, p. 22. Public domain.',
        note:'The visual system is now stripped down for mass-market instruction: a clean hand outline with named principal lines rather than manuscript density.'
      }
    ],
    'robert fludd’s cosmic monochord — turning harmony into a diagram': [
      {
        date:'1496',
        period:'Late 15th-century Renaissance',
        creator:'Guillaume Le Signerre; associated with Franchino Gaffurio’s Practica Musice',
        work:'The music of the spheres — Apollo, the Muses, planetary spheres and musical ratios',
        page:'Title-page / cosmological music diagram associated with the 1496 Milan edition of Practica Musice',
        institution:'Historical print; digital reproduction hosted by Wikimedia Commons',
        collection:'Franchino Gaffurio, Practica Musice, Milan, 1496',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/The_music_of_the_spheres.jpg?width=1200',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:The_music_of_the_spheres.jpg',
        rights:'Public domain; Commons identifies the file as free of known copyright restrictions',
        rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
        attribution:'Guillaume Le Signerre, The music of the spheres, 1496; associated with Franchino Gaffurio, Practica Musice, Milan. Public domain reproduction via Wikimedia Commons.',
        note:'This earlier Renaissance print already makes cosmic order readable through musical ratios, planetary levels and a vertical hierarchy. It gives Fludd’s later monochord a genuine visual predecessor rather than treating his 1617 plate in isolation.'
      },
      {
        date:'1617',
        period:'Early 17th century',
        creator:'Robert Fludd; production record names Johann Theodor de Bry and Hieronymus Galler',
        work:'Sonifikation der Weltordnung mit einem Monochord, from De Metaphysico Macrocosmi et creaturarum illius ortu',
        page:'p. 90; SLUB shelfmark 1.B.3237-1; Deutsche Fotothek df_tg_0006469',
        institution:'Saxon State and University Library Dresden (SLUB) / Deutsche Fotothek',
        collection:'Deutsche Fotothek; SLUB 1.B.3237-1',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Fotothek_df_tg_0006469_Theosophie_%5E_Philosophie_%5E_Sonifikation_%5E_Musik_%5E_Musikinstrument.jpg?width=1400',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Fotothek_df_tg_0006469_Theosophie_%5E_Philosophie_%5E_Sonifikation_%5E_Musik_%5E_Musikinstrument.jpg',
        rights:'Public domain historical work; reproduction marked free of known copyright restrictions under Public Domain Mark 1.0',
        rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
        attribution:'Robert Fludd, Sonifikation der Weltordnung mit einem Monochord, 1617. SLUB Dresden, 1.B.3237-1, p. 90. Deutsche Fotothek df_tg_0006469 / Wikimedia Commons, Public Domain Mark 1.0.',
        note:'Fludd reduces the correspondence between sound and cosmos to one dominant vertical device: a monochord whose measured divisions organise elemental, celestial and stellar regions.'
      },
      {
        date:'1619',
        period:'Early 17th century',
        creator:'Johannes Kepler (1571–1630)',
        work:'Musical scales or range of sound ascribed to Saturn, Jupiter, Mars, Earth, Venus and Mercury, from Harmonices Mundi',
        page:'p. 207; Library of Congress digital ID cph.3b41334; LCCN 92516399',
        institution:'Library of Congress, Prints & Photographs Division',
        collection:'Miscellaneous Items in High Demand, PPOC, Library of Congress',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Musical_scales_or_range_of_sound_ascribed_by_Kepler_to_Saturn%2C_Jupiter%2C_Mars%2C_Earth%2C_Venus%2C_and_Mercury%3B_and_surrounding_text_LCCN92516399.jpg?width=1200',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Musical_scales_or_range_of_sound_ascribed_by_Kepler_to_Saturn,_Jupiter,_Mars,_Earth,_Venus,_and_Mercury%3B_and_surrounding_text_LCCN92516399.jpg',
        rights:'Public domain; Library of Congress reports no known restrictions on publication; Commons applies Public Domain Mark 1.0',
        rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
        attribution:'Johannes Kepler, planetary musical scales from Harmonices Mundi, 1619, p. 207. Library of Congress, Prints & Photographs Division, cph.3b41334 / LCCN 92516399. Public domain.',
        note:'Kepler offers a near-contemporary alternative to Fludd: the same broad dream of cosmic harmony is expressed through labelled planetary ranges and musical scale relationships rather than a single mystical instrument.'
      },
      {
        date:'1650',
        period:'Mid-17th century',
        creator:'Athanasius Kircher',
        work:'Harmony of the birth of the world, represented by a cosmic organ, from Musurgia Universalis',
        page:'Cosmic-organ engraving in Musurgia Universalis',
        institution:'Historical book reproduction hosted by Wikimedia Commons',
        collection:'Athanasius Kircher, Musurgia Universalis, 1650',
        imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Musurgiaorgan.jpg?width=1200',
        sourceUrl:'https://commons.wikimedia.org/wiki/File:Musurgiaorgan.jpg',
        rights:'Public domain historical work and faithful two-dimensional reproduction; Public Domain Mark 1.0',
        rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
        attribution:'Athanasius Kircher, Harmony of the birth of the world, represented by a cosmic organ, Musurgia Universalis, 1650. Public domain reproduction via Wikimedia Commons.',
        note:'Kircher turns cosmic harmony into an organ three decades after Fludd. The shift from monochord to organ makes the persistence of instrument-based cosmology immediately visible while changing the composition and theological machinery.'
      }
    ]
  };

  const esc=(value)=>String(value??'').replace(/[&<>\"']/g,(c)=>({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#39;'}[c]));
  const key=(value)=>String(value||'').trim().toLowerCase();

  const installData=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    Object.entries(SOURCE_PACKS).forEach(([title,sources])=>{
      const entry=pack.entries.find((item)=>key(item&&item.title)===title);
      if(entry) entry.visualSources=sources.map((source)=>({...source}));
    });
    return true;
  };

  const sourceCard=(source)=>`<article class="ops-library__visual-source-card">
    <a class="ops-library__visual-source-image" href="${esc(source.sourceUrl)}" target="_blank" rel="noopener noreferrer">
      <img src="${esc(source.imageUrl)}" alt="${esc(source.work)}" loading="lazy">
    </a>
    <div class="ops-library__visual-source-copy">
      <p class="ops-library__visual-source-period">${esc(source.period||source.date||'Historical source')}</p>
      <h4>${esc(source.work)}</h4>
      <dl>
        ${source.date?`<div><dt>Date</dt><dd>${esc(source.date)}</dd></div>`:''}
        ${source.creator?`<div><dt>Creator</dt><dd>${esc(source.creator)}</dd></div>`:''}
        ${source.page?`<div><dt>Plate / page</dt><dd>${esc(source.page)}</dd></div>`:''}
        ${source.institution?`<div><dt>Institution</dt><dd>${esc(source.institution)}</dd></div>`:''}
        ${source.collection?`<div><dt>Collection</dt><dd>${esc(source.collection)}</dd></div>`:''}
        ${source.rights?`<div><dt>Rights</dt><dd>${source.rightsUrl?`<a href="${esc(source.rightsUrl)}" target="_blank" rel="noopener noreferrer">${esc(source.rights)}</a>`:esc(source.rights)}</dd></div>`:''}
      </dl>
      ${source.note?`<p>${esc(source.note)}</p>`:''}
      ${source.attribution?`<p class="ops-library__visual-source-attribution">${esc(source.attribution)}</p>`:''}
      <a class="ops-library__visual-source-link" href="${esc(source.sourceUrl)}" target="_blank" rel="noopener noreferrer">Open source record ↗</a>
    </div>
  </article>`;

  const render=()=>{
    installData();
    const article=document.querySelector('[data-library-article] .ops-library__article--editorial');
    if(!article||article.querySelector('[data-visual-archive]')) return;
    const title=article.querySelector('h2')?.textContent?.trim();
    if(!title) return;
    const entry=(window.OPS_OCCULT_EDITORIAL?.entries||[]).find((item)=>key(item&&item.title)===key(title));
    const sources=entry?.visualSources||[];
    if(!sources.length) return;
    const section=document.createElement('section');
    section.className='ops-library__visual-archive';
    section.dataset.visualArchive='';
    section.innerHTML=`<div class="ops-library__visual-archive-head">
      <p class="ops-library__eyebrow">VISUAL REFERENCE ARCHIVE</p>
      <h3>Compare the sources across time</h3>
      <p>${sources.length} verified visual references are kept together here so changes in composition, notation and visual language can be compared rather than flattened into one modern symbol.</p>
    </div><div class="ops-library__visual-source-grid">${sources.map(sourceCard).join('')}</div>`;
    const copy=article.querySelector('.ops-library__entry-copy');
    if(copy){
      const firstSection=copy.querySelector('.ops-library__article-section');
      if(firstSection) copy.insertBefore(section,firstSection);
      else copy.appendChild(section);
    }
  };

  const style=document.createElement('style');
  style.textContent=`
    .ops-library__visual-archive{margin:2.4rem 0 3rem;padding:1.5rem 0;border-top:1px solid rgba(22,22,22,.18);border-bottom:1px solid rgba(22,22,22,.18)}
    .ops-library__visual-archive-head{max-width:760px;margin-bottom:1.35rem}.ops-library__visual-archive-head h3{margin:.2rem 0 .55rem;font-size:clamp(1.45rem,2.5vw,2.15rem)}
    .ops-library__visual-source-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1.15rem}
    .ops-library__visual-source-card{border:1px solid rgba(22,22,22,.14);background:rgba(255,255,255,.55);min-width:0}
    .ops-library__visual-source-image{display:block;background:#eee;aspect-ratio:4/3;overflow:hidden}.ops-library__visual-source-image img{width:100%;height:100%;object-fit:contain;display:block}
    .ops-library__visual-source-copy{padding:1rem}.ops-library__visual-source-period{font-size:.75rem;letter-spacing:.08em;text-transform:uppercase;font-weight:700;margin:0 0 .35rem}.ops-library__visual-source-copy h4{margin:0 0 .8rem;font-size:1.08rem;line-height:1.25}
    .ops-library__visual-source-copy dl{margin:0 0 .9rem}.ops-library__visual-source-copy dl div{display:grid;grid-template-columns:88px 1fr;gap:.6rem;padding:.3rem 0;border-top:1px solid rgba(22,22,22,.08)}.ops-library__visual-source-copy dt{font-size:.72rem;text-transform:uppercase;letter-spacing:.04em}.ops-library__visual-source-copy dd{margin:0;font-size:.84rem}.ops-library__visual-source-copy p{font-size:.9rem}.ops-library__visual-source-attribution{font-size:.78rem!important;opacity:.72}.ops-library__visual-source-link{display:inline-block;margin-top:.25rem;font-weight:700}
    @media(max-width:749px){.ops-library__visual-source-grid{grid-template-columns:1fr}.ops-library__visual-source-copy dl div{grid-template-columns:78px 1fr}}
  `;
  document.head.appendChild(style);

  const start=()=>{
    installData();
    render();
    const target=document.querySelector('[data-library-reader]')||document.body;
    const observer=new MutationObserver(()=>render());
    observer.observe(target,{subtree:true,childList:true});
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
